import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import InlineLoader from "@Shared/components/general/inline-loader";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DownloadMppModal",
  components: {
    GenericModal,
    SimpleButton,
    InlineLoader
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    currentMpp: {
      type: Object,
      required: true
    },
    selectedMpps: {
      type: Array,
      default: () => []
    },
    currentMppDocDownloading: {
      type: Object,
      default: () => ({})
    },
    downloadingMpp: {
      type: Object,
      default: () => ({})
    },
    previewingMpp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      documentsLoaders: {}
    };
  },
  computed: {
    currentMppAppInfo() {
      return this.currentMpp.mppApplicationInformation;
    },
    currentMppDocuments() {
      const {
        mppApplicationInformation,
        documents
      } = this.currentMpp;
      if (!(documents != null && documents.length)) return [];
      return _reduceInstanceProperty(documents).call(documents, (acc, current) => {
        const currentApplicant = _findInstanceProperty(mppApplicationInformation).call(mppApplicationInformation, appInfo => {
          var _context;
          return _includesInstanceProperty(_context = current.fileName).call(_context, appInfo.applicationKey);
        }) || {};
        const {
          firstName,
          lastName
        } = currentApplicant;
        acc.push(_objectSpread(_objectSpread({}, current), {}, {
          applicant: `${firstName} ${lastName}`
        }));
        return acc;
      }, []);
    },
    documentsSelected() {
      return !!this.selectedMpps.length;
    },
    requestsTable() {
      return {
        columns: ["name", "status", "onlineApplicationLink", "viewDetails"],
        options: {
          filterable: false,
          sortable: [],
          headings: {
            name: this.$t("global.words.name"),
            email: this.$t("global.words.status"),
            onlineApplicationLink: this.$t("direct-to-lender.lenderResponse.onlineApplicationLink"),
            viewDetails: ""
          },
          columnsClasses: {
            name: "w-30",
            status: "w-30",
            onlineApplicationLink: "w-30"
          },
          perPage: 999999,
          tabbable: false,
          skin: "table mb-0",
          showChildRowToggler: false,
          uniqueKey: "id"
        }
      };
    },
    documentsTable() {
      return {
        columns: ["selected", "document", "applicant", "actions"],
        options: {
          filterable: false,
          sortable: [],
          headings: {
            selected: "",
            document: this.$t("global.words.document"),
            applicant: this.$tc("global.doorr.applicant", 1),
            actions: ""
          },
          columnsClasses: {
            document: "w-30",
            applicant: "w-20",
            selected: "text-center w-10",
            actions: "w-10"
          },
          perPage: 999999,
          tabbable: false,
          skin: "table mb-0"
        }
      };
    }
  },
  watch: {
    currentMppDocDownloading(loadingObj) {
      if (isEmpty(loadingObj)) return this.setDocumentsLoaders();
      const {
        s3Key,
        loading
      } = loadingObj;
      this.$set(this.documentsLoaders, s3Key, loading);
    }
  },
  methods: {
    handleShow() {
      this.setDocumentsLoaders();
    },
    show() {
      this.$refs.downloadMppModal.show();
    },
    viewMppDetails({
      id
    }, {
      target
    }) {
      this.toggleArrow(target);
      this.$refs.mppRequestsTable.toggleChildRow(id);
    },
    toggleArrow(target) {
      var _context2;
      const icon = _findInstanceProperty(_context2 = $(target)).call(_context2, "i");
      icon.toggleClass("fa-caret-down fa-caret-up");
    },
    badgeType(status) {
      const typeParser = {
        success: "badge-success",
        failed: "badge-danger"
      };
      return typeParser[status] || "bg-light-gray text-white";
    },
    mppDocIsSelected(fileName) {
      return this.selectedMpps.some(mpp => mpp.fileName === fileName);
    },
    handleSelectMppDoc(fileName, s3Key) {
      const document = {
        fileName,
        s3Key
      };
      this.$emit("select-mpp", document);
    },
    handleDownloadDocument() {
      this.$emit("download-mpp");
    },
    setDocumentsLoaders() {
      var _context3;
      this.documentsLoaders = _reduceInstanceProperty(_context3 = this.currentMppDocuments).call(_context3, (acc, current) => {
        acc[current.s3Key] = false;
        return acc;
      }, {});
    },
    isDocLoading(s3Key) {
      return !!this.documentsLoaders[s3Key];
    },
    handlePreviewMppDocument(document) {
      this.$emit("preview-mpp", document);
    },
    getDisabilityInsurance(info) {
      const disabilityPremium = info.applicationQuotePremium[0].disabilityInsurancePremium;
      return disabilityPremium < 0 ? "Ineligible" : `$ ${disabilityPremium}`;
    },
    getLifeInsurance(info) {
      const lifePremium = info.applicationQuotePremium[0].lifeInsurancePremium;
      return lifePremium < 0 ? "Ineligible" : `$ ${lifePremium}`;
    },
    getDisabilityInsuranceElegible(info) {
      if (info.applicationQuotePremium[0].disabilityInsurancePremium < 0) return false;
      return info.eligibleForDisabilityInsurance;
    },
    getLifeInsuranceElegible(info) {
      if (info.applicationQuotePremium[0].lifeInsurancePremium < 0) return false;
      return info.eligibleForLifeInsurance;
    }
  }
});